import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, InfoRow, Column1, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, Column2, ImgWrap, Img, ImgRound } from '../components/InfoSection/InfoElements'
import { Item, Question, Arrow, Answer } from '../components/faq'


export const faqData = [
  {
    question: "1. Na czym polega ceremonia pożegnania i czym różni się od tradycyjnego pogrzebu?",
    answer: (
      <>
        <p>
          Ceremonia pożegnania to wyjątkowe spotkanie, podczas którego skupiamy się na życiu i wspomnieniach osoby, która odeszła. To czas, by w atmosferze szacunku, bliskości i autentyczności wspólnie uhonorować jej drogę i znaczenie w życiu bliskich.
        </p>
        <p>
          W odróżnieniu od tradycyjnego pogrzebu, który często ma sztywną, religijną formę, ceremonia pożegnania daje przestrzeń do indywidualnych wyborów. Może być świecka albo zawierać elementy duchowe zgodne z wartościami zmarłej osoby i jej rodziny. Możemy wpleść w nią muzykę, symbole, osobiste wspomnienia czy rytuały, które nadają jej głęboki, osobisty wymiar.
        </p>
        <p>
          To nie jest tylko moment żałoby, ale również celebracja życia — okazja, by przypomnieć sobie, kim była ta osoba, co wnosiła do świata i jak jej historia będzie dalej żyła w pamięci i sercach bliskich.
        </p>
      </>
    )
  },
  {
    question: "2. W jakim miejscu może odbyć się ceremonia? Czy tylko w domu pogrzebowym lub przy cmentarnej kaplicy, czy gdzieś jeszcze?",
    answer: (
      <>
        <p>
          Ceremonia pożegnania może odbyć się praktycznie w każdym miejscu, które ma dla bliskich szczególne znaczenie — oczywiście po uzgodnieniu z właścicielem przestrzeni. Może to być dom pogrzebowy, kaplica przy cmentarzu, ale również sala koncertowa, galeria sztuki, ogród, a nawet stadion czy sala kinowa.
        </p>
        <p>
          Warto pamiętać, że sam pochówek podlega określonym przepisom prawnym i musi odbyć się na cmentarzu. Natomiast sama ceremonia pożegnania nie ma tak sztywnych ram. Dzięki temu można stworzyć uroczystość, która będzie naprawdę bliska wartościom i stylowi życia osoby, którą żegnamy.
        </p>
        <p>
          Trzeba jedynie wziąć pod uwagę kwestie formalne, takie jak transport trumny, który wymaga specjalistycznego samochodu zakładu pogrzebowego. Przy pochówku urnowym ograniczenia są dużo mniejsze, co daje ogromną swobodę w wyborze miejsca.
        </p>
      </>
    )
  },
  {
    question: "3. Czy mogę połączyć ceremonię pożegnania z tradycyjnym pochówkiem?",
    answer: (
      <>
        <p>
          Tak, jak najbardziej. Ceremonia pożegnania nie wyklucza tradycyjnego pogrzebu, lecz może go uzupełniać lub poprzedzać. Może odbyć się pochówek na cmentarzu w wybranym przez rodzinę obrządku religijnym, prowadzony przez księdza lub przedstawiciela danej wspólnoty wyznaniowej, a dodatkowo — kameralna ceremonia pożegnania w ogrodzie, sali kinowej, teatrze czy innym miejscu bliskim zmarłej osobie i jej bliskim.
        </p>
        <p>
          Taka ceremonia może odbyć się tuż przed pochówkiem, zaraz po nim (tego samego dnia), albo w odstępie kilku dni — w zależności od potrzeb rodziny. Często praktykuje się to w przypadku osób publicznych, które mają pogrzeby urzędowe z udziałem przedstawicieli państwa, a jednocześnie organizują osobne, bardziej intymne spotkanie tylko dla rodziny i przyjaciół.
        </p>
        <p>
          Dzięki temu pożegnanie zyskuje dwa wymiary: oficjalny i osobisty, co pozwala bliskim przeżyć je w sposób pełniejszy i zgodny z wartościami rodziny.
        </p>
      </>
    )
  },
  {
    question: "4. Ile trwa ceremonia i jak wygląda jej przebieg?",
    answer: (
      <>
        <p>
          Czas trwania ceremonii zależy od miejsca i od tego, jak zostanie zaprojektowana. W przestrzeniach takich jak kaplice cmentarne czy domy pogrzebowe obowiązują zazwyczaj ograniczenia czasowe — najczęściej jest to około 45 minut do godziny, choć czasami można zarezerwować podwójny slot.
        </p>
        <p>
          Jeśli ceremonia odbywa się w innym miejscu, np. w plenerze czy sali, czas nie jest tak sztywno ograniczony. Wtedy długość uroczystości zależy od potrzeb rodziny i tego, jakie elementy zostaną w nią wplecione. Standardowo samo pożegnanie z urną czy trumną trwa około godziny do półtorej. Często towarzyszą mu dodatkowe rytuały poza kaplicą czy salą, które wydłużają cały proces.
        </p>
        <p>
          Trzeba też pamiętać, że jest to uroczystość bardzo intensywna emocjonalnie — zazwyczaj godzina, półtorej to czas wystarczający, by przeżyć ją w pełni. Zdarzają się jednak także rozszerzone formy, np. połączone z warsztatami, podczas których bliscy wspólnie tworzą wieńce czy pamiątki. W takich sytuacjach całe spotkanie może trwać nawet kilka godzin, a czasem cały dzień.
        </p>
        <p>
          Nie ma jednego sztywnego schematu — każda ceremonia jest projektowana indywidualnie, tak by odpowiadała potrzebom i możliwościom rodziny oraz najlepiej oddawała życie i wartości żegnanej osoby.
        </p>
      </>
    )
  },
  {
    question: "5. Jakie symbole i rytuały mogę wpleść w ceremonię?",
    answer: (
      <>
        <p>
          Symbole i rytuały są sercem ceremonii pożegnania — nadają jej osobisty charakter i sprawiają, że staje się ona doświadczeniem wspólnotowym i zmysłowym. Nie ma jednego wzoru, ponieważ każda uroczystość jest projektowana indywidualnie, w oparciu o życie i historię żegnanej osoby.
        </p>
        <p>
          Mogą to być proste gesty, w które włączają się wszyscy uczestnicy — rozdawanie świec czy kwiatów, układanie ich w wybrany sposób, wspólne śpiewanie pieśni ze specjalnie przygotowanych śpiewników. Czasem zamiast tradycyjnego sypania ziemi do grobu używa się płatków róż, liści drzew czy innych symbolicznych elementów.
        </p>
        <p>
          Symbole często odwołują się do tego, co było bliskie zmarłej osobie. Jeśli zbierała pióra — w ceremonii mogą pojawić się piórka. Jeśli miała ulubiony zapach — można wpleść aromaterapię lub kadzidła. Mogą to być też kamienie, balony, bańki mydlane czy inne przedmioty, które w subtelny, ale wyrazisty sposób przywołają jej obecność i znaczenie.
        </p>
        <p>
          Ceremonia działa na wiele zmysłów — nie tylko poprzez słowa, ale także muzykę, zapachy, dotyk czy obraz. Dzięki temu uczestnicy nie tylko słuchają, ale też aktywnie uczestniczą, czując, że tworzą most między sobą a osobą, którą żegnają.
        </p>
      </>
    )
  },
  {
    question: "6. Jak długo przygotowujesz ceremonię pożegnania?",
    answer: (
      <>
        <p>
          Do każdej ceremonii przygotowuję się głęboko i z pełnym zaangażowaniem. Proces tworzenia pożegnania trwa zazwyczaj od trzech do około siedmiu dni, w zależności od złożoności scenariusza, liczby uczestników i wybranego pakietu.
        </p>
        <p>
          Nie korzystam z gotowych szablonów ani powtarzalnych tekstów — każda ceremonia powstaje od podstaw, z uwzględnieniem indywidualnych potrzeb rodziny, historii życia osoby, na której cześć powstaje uroczystość, oraz atmosfery, jaką chcemy wspólnie stworzyć.
        </p>
        <p>
          W tym czasie pracuję bardzo intensywnie — zdarza się, że w ciągu trzech dni spędzam przy przygotowaniach więcej roboczogodzin, niż przy projektach realizowanych przez dwa tygodnie. Każda ceremonia wymaga od kilkunastu do kilkudziesięciu godzin pracy, ponieważ tworzę ją z pełną uważnością na szczegóły, symbolikę i emocjonalny wymiar spotkania.
        </p>
        <p>
          W przypadku ceremonii pogrzebowych dochodzi również element działania w krótkim czasie — formalności i terminy pochówków wymagają sprawności, wrażliwości i szybkiego reagowania. Dlatego pracuję z dużą koncentracją i odpowiedzialnością, aby w krótkim czasie stworzyć coś, co będzie naprawdę piękne, spójne i pełne znaczenia.
        </p>
      </>
    )
  },
  {
    question: "7. Czy mogę zorganizować ceremonię dla osoby niewierzącej?",
    answer: (
      <>
        <p>
          Oczywiście, że tak. Ceremonia pożegnania nie musi mieć charakteru religijnego — jej głównym celem jest stworzenie bezpiecznej, wspierającej przestrzeni, w której bliscy mogą wspólnie przejść przez pierwszy etap żałoby.
        </p>
        <p>
          Podczas ceremonii dbam o to, aby pojawiły się elementy, które stabilizują, łączą i pomagają w przeżywaniu straty. Wykorzystuję m.in. model „Kalejdoskopu żałoby” Chris Powell, który wskazuje sześć kluczowych obszarów potrzebnych do zdrowego przechodzenia żałoby: przetrwanie i stabilizacja, adaptacja, emocje, rzeczywistość straty, więź oraz znaczenie.
        </p>
        <p>
          Ceremonia służy więc nie tylko upamiętnieniu osoby, która odeszła, ale przede wszystkim wsparciu tych, którzy zostali. Niezależnie od tego, czy ktoś wierzył, czy nie wierzył, taki rytuał ma głęboki sens i wartość.
        </p>
      </>
    )
  },
  {
    question: "8. Jak wygląda proces od pierwszego kontaktu do dnia ceremonii?",
    answer: (
      <>
        <p>Cały proces jest jasny i przejrzysty, tak aby w tych trudnych chwilach mieć poczucie bezpieczeństwa i wsparcia. W skrócie wygląda on tak:</p>
        <ol className="list-decimal ml-6">
          <li>Kontakt – pierwszy krok to wiadomość lub telefon do mnie.</li>
          <li>Rozmowa wstępna – wspólnie omawiamy potrzeby i oczekiwania.</li>
          <li>Propozycja – przygotowuję wstępną koncepcję ceremonii.</li>
          <li>Wybór pakietu – dopasowujemy zakres wsparcia i usług.</li>
          <li>Spotkanie przygotowawcze – ustalamy szczegóły, historię życia bliskiej osoby, symbole i rytuały.</li>
          <li>Opracowanie scenariusza – tworzę spójną całość uroczystości.</li>
          <li>Koordynacja i współpraca z domem pogrzebowym (jeśli to potrzebne).</li>
          <li>Dzień ceremonii – prowadzę uroczystość i dbam o każdy szczegół.</li>
        </ol>
        <p>
          Pełny opis wszystkich kroków znajdziesz w zakładce „Ceremonie”, gdzie szczegółowo przedstawiam, jak wygląda współpraca od początku do końca.
        </p>
      </>
    )
  },
  {
    question: "9. Czy to ja decyduję o kształcie ceremonii, czy wszystko jest ustalane przez Ciebie?",
    answer: (
      <>
        <p>
          Ceremonia jest projektowana i prowadzona przeze mnie jako mistrza ceremonii — dbam o spójność, rytm i przebieg uroczystości. Jednak nie oznacza to, że wszystko jest narzucone z góry. Wręcz przeciwnie — ustalam projekt z Tobą i Twoją rodziną, tak aby ceremonia w pełni oddawała życie, wartości i historię bliskiej osoby.
        </p>
        <p>
          Można powiedzieć, że to praca wspólna: Ty wnosisz wspomnienia, potrzeby i pragnienia dotyczące pożegnania, a ja łączę je z moim doświadczeniem i wachlarzem symboli, rytuałów i form, które sprawiają, że całość jest harmonijna i głęboko poruszająca.
        </p>
        <p>
          Dzięki temu masz pewność, że ceremonia jest profesjonalnie przygotowana, a jednocześnie autentyczna i wyjątkowa — taka, która naprawdę odzwierciedla osobę, której ciało żegnacie.
        </p>
      </>
    )
  },
  {
    question: "10. Uczestnictwo dzieci w pogrzebach — czy to dobry pomysł?",
    answer: (
      <>
        <p>
          Zdecydowanie tak. Dzieci mają prawo uczestniczyć w pożegnaniu bliskiej osoby, bo śmierć jest częścią naturalnego cyklu życia. Udawanie, że ktoś „wyjechał” albo „zniknął”, może w przyszłości rodzić lęk, nieufność czy trudności w przeżywaniu emocji. Oczywiście sposób, w jaki dziecko uczestniczy w ceremonii, powinien być zawsze adekwatny do jego wieku i wrażliwości.
        </p>
        <p>
          Podczas przygotowań do ceremonii często proponuję rodzinom, aby dzieci i wnuki mogły włączyć się w symboliczny sposób — narysować obrazek, który później ozdobi przestrzeń pożegnania, napisać kilka słów do babci czy dziadka, przynieść ulubioną zabawkę lub pamiątkę. To nie tylko pozwala im wyrazić emocje, ale też daje poczucie, że są częścią wspólnoty i procesu żegnania.
        </p>
        <p>
          Warto też zapytać dziecko, czy chce wziąć udział w ceremonii i w jakiej formie. Dla młodszych dzieci pięknym gestem może być puszczanie baniek mydlanych przy grobie — symbol ulotności, ale też lekkości i powrotu do życia.
        </p>
        <p>
          Dobre domy pogrzebowe często potrafią stworzyć przyjazną przestrzeń z kącikiem dla dzieci — z kredkami, wodą czy zabawką. Jednak taką przestrzeń można też przygotować samodzielnie, dbając o potrzeby najmłodszych uczestników.
        </p>
        <p>
          Pamiętam jedną ceremonię pożegnania bardzo małego dziecka, podczas której rodzice poprosili gości, by przyszli razem ze swoimi dziećmi. Pożegnanie odbywało się w sali wypełnionej kredkami, książkami i zabawkami — miejscem, które oddychało życiem.
        </p>
        <p>
          Rodzice chcieli, by mimo bólu można było poczuć obecność życia, radości i sensu. Wśród śmiechu i obecności wielu dzieci rozbrzmiewała najczystsza prawda: że życie, choć kruche, trwa dalej.
        </p>
        <p>
          Obecność dzieci na ceremonii, przy odpowiednim wsparciu dorosłych, pomaga im lepiej zrozumieć rzeczywistość straty i łagodniej wejść w proces żałoby. To inwestycja w ich emocjonalną dojrzałość i zdolność do radzenia sobie z trudnymi momentami w przyszłości.
        </p>
      </>
    )
  },
  {
    question: "11. Ile kosztuje ceremonia pożegnania?",
    answer: (
      <>
        <p>
          Zachęcam, aby zajrzeć do zakładki „Pakiety ceremonii”, gdzie znajdują się przykładowe zakresy i warianty współpracy. Każda ceremonia jest projektowana indywidualnie — jej koszt zależy od stopnia złożoności, ilości przygotowań, miejsca oraz liczby osób zaangażowanych w proces.
        </p>
        <p>
          Najbardziej ekonomiczna, prosta forma ceremonii, czyli samo prowadzenie uroczystości przygotowanej wcześniej przez rodzinę (bez pokazu slajdów, rozbudowanych rytuałów czy elementów artystycznych), trwa około 30 minut i kosztuje od 1 700 zł.
        </p>
        <p>
          W przypadku rozbudowanych ceremonii — wieloczęściowych, odbywających się w nietypowych lokalizacjach, z muzyką na żywo, tłumaczeniem lub udziałem osób publicznych — cena jest wyższa i ustalana indywidualnie. Większość ceremonii, które projektuję i prowadzę, mieści się w przedziale od 3 000 do 5 500–7 000 zł, w zależności od wybranego pakietu i zakresu prac. Bywają i takie, gdzie nadzoruję całość od początku do końca wydarzenia (w tym przyjęcie — tzw. stypa), wtedy koszt może wynieść nawet 15 000 zł.
        </p>
        <p>
          W cenę wliczone są m.in. przygotowanie koncepcji i scenariusza ceremonii, prowadzenie uroczystości, kontakt z podwykonawcami (jeśli dotyczy), a także drobne materiały symboliczne — np. płatki kwiatów, świece, piórka czy wydruki wspomnieniowe.
        </p>
        <p>
          Dodatkowe usługi, takie jak pokazy slajdów, księgi pamiątkowe, albumy, oprawa muzyczna, tłumaczenia czy wynajem sali, są rozliczane osobno — według indywidualnej wyceny.
        </p>
        <p>
          Warto pamiętać, że podane ceny nie obejmują usług zakładu pogrzebowego ani formalności urzędowych i cmentarnych. Moja praca dotyczy wyłącznie projektowania i prowadzenia ceremonii pożegnania.
        </p>
        <p>
          Na terenie Wrocławia oraz w promieniu do 50 km dojazd jest wliczony w cenę. W przypadku dalszych lokalizacji doliczany jest koszt podróży, ustalany indywidualnie.
        </p>
        <p>
          Jeśli chcesz poznać przybliżoną wycenę dla swojej sytuacji, napisz do mnie — po krótkiej rozmowie przedstawię kosztorys dopasowany do potrzeb i charakteru planowanej uroczystości.
        </p>
      </>
    )
  },
  {
    question: "12. Czy pogrzeb dla zwierzęcia domowego można zorganizować w tak samo zaawansowany sposób jak dla człowieka?",
    answer: (
      <>
        <p>
          Oczywiście, że tak. Ceremonia pożegnania zwierzęcia może być przygotowana z taką samą uważnością, symboliką i głębią, jak ceremonie organizowane dla ludzi. Zwierzęta są przecież częścią rodziny – obecne w codzienności, w sercu, w relacji, która zasługuje na piękne i godne upamiętnienie.
        </p>
        <p>
        W praktyce oznacza to, że możesz wybrać jeden z tych samych pakietów ceremonii, które przygotowuję dla pożegnań ludzkich – dostosowany jedynie do specyfiki sytuacji. Zakres symboli, rytuałów, oprawy muzycznej i słów dobieramy wspólnie, tak by stworzyć ceremonię pełną sensu, miłości i wdzięczności – na cześć życia, które pozostawiło po sobie ślad.        </p>
      </>
    )
  },
  {
    question: "13. Czy to znaczy, że pogrzeb jest „rytuałem przejścia”?",
    answer: (
      <>
        <p>
          Rytuały przejścia to symboliczne momenty w życiu, które pomagają nam przejść z jednego etapu do drugiego – jak narodziny, ślub, czy właśnie pożegnanie ze światem fizycznym. Pogrzeb w tej formie jest zarówno domknięciem cyklu życia osoby, która odeszła, jak i momentem przejścia dla bliskich — z bólu w stronę akceptacji, z chaosu w stronę porządku.
        </p>
        <p>
          Dobrze zaprojektowany rytuał przejścia pomaga odnaleźć znaczenie w sytuacji granicznej i daje poczucie spokoju, że to, co ważne, zostało nazwane, uhonorowane i usłyszane.
        </p>
      </>
    )
  },
  {
    question: "14. Czym jest „wieczór pamięci”?",
    answer: (
      <>
        <p>
          To intymne spotkanie dla rodziny i przyjaciół — czas, by bez pośpiechu uczcić życie osoby, która odeszła, zanim nastąpi właściwa ceremonia pożegnania.
        </p>
        <p>
          Wieczór pamięci może odbywać się w domu, w ogrodzie, w wynajętej przestrzeni lub przy urnie — często przy świecach, z muzyką, opowieściami, wspomnieniami i symbolami.
        </p>
        <p>
          To moment zatrzymania, wspólnego bycia, wdzięczności i oswojenia tego, co trudne. Często przygotowuję na takie spotkanie delikatne rytuały — np. zapalanie świec, czytanie listów lub wspólne tworzenie wieńca z intencjami.
        </p>
      </>
    )
  },
  {
    question: "15. Czy można zorganizować pogrzeb bez mowy pożegnalnej?",
    answer: (
      <>
        <p>
          Tak. Słowa to tylko jeden ze sposobów wyrażania miłości.
        </p>
        <p>
          Czasem więcej mówią gesty, obrazy, muzyka czy cisza.
        </p>
        <p>
          Jeżeli nie czujesz potrzeby przemówień, ceremonia może opierać się na wspólnych rytuałach – zapaleniu świec, ułożeniu kwiatów, puszczeniu ulubionej piosenki czy symbolicznym pożegnaniu w milczeniu.
        </p>
        <p>
          Ważne, by forma była spójna z tym, kim była osoba żegnana i czego potrzebują jej bliscy.
        </p>
      </>
    )
  },
  {
    question: "16. Jaka muzyka może towarzyszyć ceremonii?",
    answer: (
      <>
        <p>
          Każda, która ma znaczenie. Od utworów klasycznych i filmowych, przez poezję śpiewaną, aż po rock, jazz, mantry, a nawet taneczne brzmienia.
        </p>
        <p>
          Muzyka jest jednym z najgłębiej działających elementów ceremonii – otwiera serce i pozwala poczuć to, czego nie da się wyrazić słowami.
        </p>
        <p>
          Zdarzało mi się prowadzić ceremonie, podczas których rodzina grała lub śpiewała własnoręcznie, a także takie, w których cisza była najpiękniejszym dźwiękiem.
        </p>
      </>
    )
  },
  {
    question: "17. Czy rodzina może zaangażować się w prowadzenie ceremonii?",
    answer: (
      <>
        <p>
          Zdecydowanie tak.
        </p>
        <p>
          Bardzo zachęcam, by rodzina i bliscy współtworzyli ceremonię – pisali słowa pożegnania, przynosili pamiątki, przygotowywali muzykę, zdjęcia lub własne rytuały.
        </p>
        <p>
          Takie współdziałanie daje poczucie wspólnoty i sprawia, że ceremonia staje się autentyczna i żywa, a nie „wyreżyserowana z zewnątrz”.
        </p>
        <p>
          Czasem są to małe gesty – np. ułożenie kwiatów, wypuszczenie baniek mydlanych, podanie świecy dalej w kręgu – a czasem całe współprowadzenie wydarzenia.
        </p>
      </>
    )
  },
  {
    question: "18. Czy mogę przyjść na ceremonię z psem lub innym zwierzęciem?",
    answer: (
      <>
        <p>
          Jeśli miejsce na to pozwala – tak.
        </p>
        <p>
          Zdarzało mi się prowadzić pożegnania, podczas których obecny był ukochany pies osoby zmarłej.
        </p>
        <p>
          Zwierzęta, podobnie jak ludzie, czują stratę i reagują na emocje bliskich. Ich obecność potrafi przynieść ukojenie, poczucie ciągłości i ciepła.
        </p>
        <p>
          Jeżeli to dla Ciebie ważne, pomogę znaleźć sposób, by obecność zwierzęcia była możliwa – zawsze z poszanowaniem zasad miejsca i komfortu innych uczestników.
        </p>
      </>
    )
  },
  {
    question: "19. Jak ubiera się mistrzyni ceremonii?",
    answer: (
      <>
        <p>
          Ubieram się stosownie do charakteru ceremonii i z poszanowaniem jej symboliki, ale także w zgodzie ze sobą.
        </p>
        <p>
          Zazwyczaj wybieram naturalne tkaniny – len, jedwab, bawełnę, wełnę – w stonowanych, ziemistych barwach: beżach, brązach, bieli.
        </p>
        <p>
          Nie noszę urzędowych tog, łańcuchów czy czarnych kapeluszy – nie jestem urzędnikiem państwowym, tylko projektantką rytuałów i opiekunką przejścia.
        </p>
        <p>
          Czasem wplatam w ubiór delikatne symbole: pióro, kamień, element natury. W wyjątkowych przypadkach – np. gdy żegnamy dziecko – może pojawić się subtelny akcent kolorystyczny, który ma dla rodziny znaczenie.
        </p>
      </>
    )
  },
  {
    question: "20. Jakie mam przygotowanie i doświadczenie zawodowe?",
    answer: (
      <>
        <p>
          Ukończyłam kurs Mistrzów Ceremonii Pogrzebowych organizowany przez Instytut Dobrej Śmierci, prowadzony przez Anię Franczak.
        </p>
        <p>
          Swoją ścieżkę zawodową od lat buduję na głębokim połączeniu z tematyką żałoby i transformacji.
        </p>
        <p>
          Przez wiele lat pracowałam w branży kamieniarskiej, projektując pomniki i towarzysząc ludziom w pierwszych momentach po stracie.
        </p>
        <p>
          Jestem także certyfikowaną socjoterapeutką i coachem, co pozwala mi wspierać proces emocjonalny uczestników.
        </p>
        <p>
          Prowadzę sesje coachingowe i socjoterapeutyczne dla osób po stracie.
        </p>
        <p>
          Ukończyłam również i wciąż pogłębiam naukę Energy Craftingu – autorskiej metody pracy z energią, emocjami i pamięcią ciała.
        </p>
        <p>
          Z wykształcenia jestem magistrem Communication Design Uniwersytetu Wrocławskiego, co uczy mnie tworzyć narracje i przestrzenie pełne znaczenia.
        </p>
        <p>
          Od lat inwestuję w rozwój pod okiem najlepszych mentorów i terapeutów na świecie, łącząc naukę, duchowość i sztukę w praktyce, która przywraca człowieka do życia.
        </p>
        <p>
          Jeśli chcesz zobaczyć listę moich kursów i certyfikatów – wkrótce znajdziesz je w dedykowanej zakładce na stronie.
        </p>
      </>
    )
  },
  {
    question: "21. Z jakimi zakładami pogrzebowymi współpracuję?",
    answer: (
      <>
        <p>
          Współpracuję z różnymi domami pogrzebowymi na terenie całej Polski, a także z lokalnymi firmami, które są otwarte na nowoczesne, humanistyczne podejście.
        </p>
        <p>
          Często jednak to rodziny kontaktują się ze mną zanim wybiorą zakład, dzięki czemu mogę pomóc w znalezieniu miejsca odpowiadającego ich potrzebom, wartościom i wizji pożegnania.
        </p>
        <p>
          Zawsze dążę do współpracy opartej na szacunku, empatii i elastyczności – tak, by całość przebiegła spokojnie i z uważnością.
        </p>
      </>
    )
  },
  {
    question: "22. Czy można zaplanować własną ceremonię pożegnalną?",
    answer: (
      <>
        <p>
          Tak, coraz więcej osób decyduje się świadomie zaplanować własne pożegnanie – jako formę domknięcia, troski o bliskich i wyrażenia siebie.
        </p>
        <p>
          Podczas spotkań tworzymy dokument zawierający wizję ceremonii, muzykę, symbole, a nawet słowa, które mają wybrzmieć.
        </p>
        <p>
          Taki plan można przechować z innymi ważnymi dokumentami.
        </p>
        <p>
          To akt odwagi i miłości – zostawić po sobie coś więcej niż wspomnienie: zostawić intencję, atmosferę i przesłanie.
        </p>
      </>
    )
  },
  {
    question: "23. Co to jest „uziemiona duchowość”?",
    answer: (
      <>
        <p>
          To podejście do życia i pożegnań poza religią, ale z duszą.
        </p>
        <p>
          Uznaje, że człowiek to nie tylko ciało i umysł, lecz także świadomość, duch i dusza, a także głębia przeżyć – i że sens, wartości oraz relacje nadają życiu kierunek.
        </p>
        <p>
          To duchowość osadzona w ciele, emocjach i codzienności, a nie w dogmatach; bliska uważności, wdzięczności i symbolice, które pomagają przejść przez zmianę i żałobę.
        </p>
        <p>W praktyce oznacza:</p>
        <ul className="ml-6 list-disc">
          <li>język pełen szacunku i czułości – taki, w którym każdy może się odnaleźć, niezależnie od swoich przekonań,</li>
          <li>proste, czułe rytuały (muzyka, słowa, gesty, symbole natury), które wspierają przeżywanie i domykanie tego, co ważne,</li>
          <li>pracę z ciałem i oddechem, by wrócić do obecności „tu i teraz”,</li>
          <li>pielęgnowanie więzi i wspomnień z osobą, którą żegnamy – tak, by miłość mogła trwać w innej formie.</li>
        </ul>
        <p>To nie jest:</p>
        <ul className="ml-6 list-disc">
          <li>żadna sekta, doktryna czy „magia”,</li>
          <li>nurt New Age ani obietnica nadzwyczajnych zjawisk,</li>
          <li>zastąpienie terapii – to wspierająca przestrzeń i świadome rytuały, które towarzyszą procesowi żałoby.</li>
        </ul>
        <p>
          Dlaczego „poza religią”?
        </p>
        <p>
          Bo religia to zorganizowany system wierzeń i praktyk, podczas gdy duchowość w tym ujęciu dotyczy sensu, świadomości i wewnętrznego doświadczenia – może być obecna niezależnie od wyznania.
        </p>
        <p>
          W tej przestrzeni każdy – wierzący lub nie – ma prawo do godnego, prawdziwego i głębokiego pożegnania.
        </p>
        <p>
          💗Sedno: Uziemiona duchowość koncentruje się na życiu – na miłości, która zostaje, na obecności, która przenika, i na czułych gestach, które pomagają iść dalej w zgodzie z duszą.
        </p>
      </>
    )
  },
  {
    question: "24. Czy można zorganizować ceremonię pożegnania zwierzęcia?",
    answer: (
      <>
        <p>
          Tak. Zwierzęta często są członkami rodziny, towarzyszami życia, miłości i codzienności. Ceremonia pożegnania zwierzęcia jest formą uhonorowania tej więzi – przestrzenią, w której można wyrazić wdzięczność, miłość i ból po stracie istoty, która dawała bezwarunkową obecność.
        </p>
        <p>
          Takie pożegnanie może przyjąć różną formę – od symbolicznego rytuału w domu lub ogrodzie, przez ciche spotkanie w naturze, aż po bardziej rozbudowaną ceremonię z muzyką, wspomnieniami i symbolami.
        </p>
        <p>
          Każda z nich ma jeden cel: pomóc sercu się domknąć, a więzi pozostać – w innej, duchowej formie.
        </p>
      </>
    )
  },
  {
    question: "25. Gdzie może odbyć się pożegnanie zwierzęcia?",
    answer: (
      <>
        <p>
          Wybór miejsca zależy od tego, co było bliskie zwierzęciu i jego opiekunom. Może to być ogród, las, łąka, ulubione miejsce spacerów, przestrzeń przy domu lub specjalne cmentarzysko dla zwierząt.
        </p>
        <p>
          Jeśli zwierzę zostało skremowane, ceremonię można połączyć z rozsypaniem prochów, zapaleniem świec lub zasadzeniem rośliny pamięci.
        </p>
        <p>
          Nie ma jednego właściwego sposobu – ważne, by miejsce było spokojne, bezpieczne i pozwalało symbolicznie „zostać jeszcze chwilę razem”.
        </p>
      </>
    )
  },
  {
    question: "26. Jak wygląda taka ceremonia?",
    answer: (
      <>
        <p>
          Ceremonia pożegnania zwierzęcia jest projektowana indywidualnie – w rytmie serca opiekuna i z szacunkiem do historii wspólnego życia.
        </p>
        <p>
          Można w niej odczytać list, przygotować pamiątkowe zdjęcia, zapalić świecę, puścić ulubioną muzykę lub złożyć zwierzęcy amulet.
        </p>
        <p>
          Czasem pojawia się symboliczne „pożegnanie z ciałem”, a czasem tylko spotkanie przy prochach lub wspólne milczenie w naturze.
        </p>
        <p>
          To moment, w którym człowiek może nadać kształt temu, co niewidzialne – miłości, wdzięczności i tęsknocie.
        </p>
      </>
    )
  },
  {
    question: "27. Czy prowadzisz takie ceremonie osobiście?",
    answer: (
      <>
        <p>
          Tak, prowadzę ceremonie pożegnań zwierząt zarówno na Dolnym Śląsku, jak i w innych regionach Polski – w zależności od dostępności i ustaleń.
        </p>
        <p>
          Każde pożegnanie przygotowuję z tą samą uważnością, jak w przypadku ceremonii ludzkich – z troską o rytm, atmosferę i symbolikę.
        </p>
        <p>
          Wspólnie z opiekunem ustalamy przebieg i charakter ceremonii tak, aby była zgodna z jego emocjami i przekonaniami.
        </p>
        <p>
          Dla wielu osób to pierwszy krok ku ukojeniu bólu po stracie i przywróceniu w sercu miejsca na wspomnienia pełne czułości.
        </p>
      </>
    )
  },
  {
    question: "28. Czy mogę zamówić urnę lub pamiątkę po zwierzęciu?",
    answer: (
      <>
        <p>
          Tak. Współpracuję z lokalnymi pracowniami, które tworzą delikatne, symboliczne pamiątki po ukochanych zwierzętach – urny, biżuterię pamięci, figurki, kamienie czy szkatułki z prochami.
        </p>
        <p>
          Często doradzam też, jak samodzielnie stworzyć mały ołtarzyk pamięci w domu – z fotografią, świecą, rośliną lub drobnym symbolem, który przypomina o więzi, a nie o stracie.
        </p>
      </>
    )
  },
  {
    question: "29. Czy ceremonia pożegnania zwierzęcia ma sens, jeśli minęło już dużo czasu od jego śmierci?",
    answer: (
      <>
        <p>
          Jak najbardziej.
        </p>
        <p>
          Nie ma „zbyt późno” na pożegnanie. Czasem dopiero po miesiącach czy latach czujemy gotowość, by symbolicznie zamknąć ten rozdział – zapalić świecę, wypowiedzieć słowa, których wtedy zabrakło, lub po prostu pobyć we wspomnieniu.
        </p>
        <p>
          Taka ceremonia pomaga nadać znaczenie temu, co pozostało niewypowiedziane, i przywraca relację w nowej, spokojniejszej formie – z miejsca miłości, nie bólu.
        </p>
      </>
    )
  }
];

const AccordionItem = ({ faq, index, activeIndex, setActiveIndex }) => {
  const isOpen2 = index === activeIndex;

  const toggle2 = () => {
    setActiveIndex(isOpen2 ? null : index);
  };

return (
    <Item>
      <Question onClick={toggle2}>
        <span>{faq.question}</span>
        <Arrow isOpen={isOpen2}>▼</Arrow>
      </Question>
      <Answer isOpen={isOpen2}>{faq.answer}</Answer>
    </Item>
  );
};

const Help = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    const [activeIndex, setActiveIndex] = useState(null);

return (
    <>
      <Navbar toggle={toggle} />
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <InfoContainer3 lightBg='true'>
        <InfoWrapper>
          {faqData.map((faq, index) => (
            <AccordionItem
              key={index}
              faq={faq}
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
            />
          ))}
                  <h2>
          Nie znalazłeś odpowiedzi na swoje pytanie? Napisz do mnie – z przyjemnością wyjaśnię, doradzę i pomogę Ci zaplanować wszystko tak, byś mógł poczuć spokój i pewność w tym ważnym czasie.
        </h2>
        </InfoWrapper>

      </InfoContainer3>
      <Footer />
    </>
  );
};

export default Help